export const ITINERARY_PROPOSAL_SAMPLE = {
  quote: {
    quote_number: "TR-1776756991862",
    broker_org_id: "94d76474-c055-4882-ab9d-651c29cf5fb9",
    created_by: "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
    client_id: "758cbb92-56b3-4421-a22e-862d637325f5",
    departure_airport: "A23",
    arrival_airport: "A63",
    departure_date: "2026-04-23T07:34:00",
    return_date: null,
    is_round_trip: false,
    is_multi_leg: true,
    passenger_count: 1,
    status: "SENT",
    payment_status: null,
    flight_cost: null,
    federal_excise_tax: "0.00",
    segment_tax: null,
    total_due: "48.66",
    card_fee: null,
    operator_cost: null,
    broker_margin: "47.93",
    platform_fee: "0.73",
    note_to_client: "",
    quote_id: "f9dba03d-ec2e-4ac6-8155-6dcb78c12936",
    created_at: "2026-04-21T07:36:44.404293Z",
    updated_at: "2026-04-21T07:36:44.404317Z",
    passengers: [],
    bid_items: [
      {
        quote_id: "f9dba03d-ec2e-4ac6-8155-6dcb78c12936",
        bid_id: "70e8b80a-0dc2-494e-9477-602ac816d29a",
        quote_bid_item_id: "c8d63901-08cf-4352-8397-c293c2a741f1",
        created_at: "2026-04-21T07:36:44.536477Z",
        updated_at: "2026-04-21T07:36:44.536483Z",
        bid: {
          trip_number: "T236350",
          broker_org_id: "94d76474-c055-4882-ab9d-651c29cf5fb9",
          broker_id: "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
          created_by: "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
          client_name: "Kervin Kervin",
          client_email: "kgatchalian@trustjet.ai",
          client_phone: "",
          departure_airport: "A23",
          arrival_airport: "A63",
          departure_date: "2026-04-23T07:34:00",
          return_date: null,
          passenger_count: 1,
          baggage_requirements: "",
          special_requests: "",
          status: "DRAFT",
          total_amount: "48.66",
          currency: "USD",
          valid_until: "2026-04-30T00:00:00",
          sent_at: null,
          viewed_at: null,
          accepted_at: null,
          notes: "",
          message_id: null,
          leg_itinerary: [
            {
              pax: 1,
              departure_date: "2026-04-23T07:34:00.000Z",
              arrival_address: null,
              arrival_airport: "A63",
              departure_address: null,
              departure_airport: "A23",
            },
            {
              pax: 1,
              departure_date: "2026-04-29T07:35:00.000Z",
              arrival_address: null,
              arrival_airport: "BGBW",
              departure_address: null,
              departure_airport: "BGAA",
            },
            {
              pax: 1,
              departure_date: "2026-05-07T19:35:00.000Z",
              arrival_address: null,
              arrival_airport: "CAB3",
              departure_address: null,
              departure_airport: "C65",
            },
          ],
          bid_id: "70e8b80a-0dc2-494e-9477-602ac816d29a",
          created_at: "2026-04-21T07:36:42.064386",
          updated_at: "2026-04-21T07:36:42.064386",
          broker_org: {
            name: "AVSKY CHARTER VENTURES, INC.",
            type: "BROKER",
            subscription_tier: "STARTER",
            billing_email: "kg@trustjet.ai",
            tax_id: null,
            address: {
              street: "Address",
            },
            settings: {
              isSole: false,
              pocTitle: "Chief Operating Officer",
              countryCode: "+1",
              countryName: "United States",
            },
            payment_platforms: {
              stripe: {
                email: "nino.gabon@gmail.com",
                created: 1770695508,
                requirements: {
                  past_due: [
                    "external_account",
                    "tos_acceptance.date",
                    "tos_acceptance.ip",
                  ],
                  currently_due: [
                    "external_account",
                    "tos_acceptance.date",
                    "tos_acceptance.ip",
                  ],
                  eventually_due: [
                    "external_account",
                    "tos_acceptance.date",
                    "tos_acceptance.ip",
                  ],
                  pending_verification: [],
                },
                charges_enabled: false,
                payouts_enabled: false,
                stripe_account_id: "acct_1Sz7zKHvAj2QHXKp",
                processor_response: {
                  id: "acct_1Sz7zKHvAj2QHXKp",
                  type: "none",
                  email: "nino.gabon@gmail.com",
                  object: "account",
                  company: {
                    name: null,
                    address: {
                      city: null,
                      line1: null,
                      line2: null,
                      state: null,
                      country: "US",
                      postal_code: null,
                    },
                    verification: {
                      document: {
                        back: null,
                        front: null,
                        details: null,
                        details_code: null,
                      },
                    },
                    owners_provided: false,
                    tax_id_provided: false,
                    directors_provided: false,
                    executives_provided: false,
                  },
                  country: "US",
                  created: 1770695508,
                  metadata: {
                    organization_id: "e979027a-e643-41d9-8ce9-49b14d86382b",
                    organization_name: "TestOrgTrustJet",
                  },
                  settings: {
                    payouts: {
                      schedule: {
                        interval: "daily",
                        delay_days: 2,
                      },
                      statement_descriptor: null,
                      debit_negative_balances: true,
                    },
                    branding: {
                      icon: null,
                      logo: null,
                      primary_color: null,
                      secondary_color: null,
                    },
                    invoices: {
                      default_account_tax_ids: null,
                      hosted_payment_method_save: "offer",
                    },
                    payments: {
                      statement_descriptor: null,
                      statement_descriptor_kana: null,
                      statement_descriptor_kanji: null,
                    },
                    dashboard: {
                      timezone: "Etc/UTC",
                      display_name: null,
                    },
                    card_issuing: {
                      tos_acceptance: {
                        ip: null,
                        date: null,
                      },
                    },
                    card_payments: {
                      decline_on: {
                        avs_failure: false,
                        cvc_failure: false,
                      },
                      statement_descriptor_prefix: null,
                      statement_descriptor_prefix_kana: null,
                      statement_descriptor_prefix_kanji: null,
                    },
                    paypay_payments: {},
                    bacs_debit_payments: {
                      display_name: null,
                      service_user_number: null,
                    },
                    sepa_debit_payments: {},
                  },
                  controller: {
                    fees: {
                      payer: "application",
                    },
                    type: "application",
                    losses: {
                      payments: "application",
                    },
                    is_controller: true,
                    stripe_dashboard: {
                      type: "express",
                    },
                    requirement_collection: "stripe",
                  },
                  login_links: {
                    url: "/v1/accounts/acct_1Sz7zKHvAj2QHXKp/login_links",
                    data: [],
                    object: "list",
                    has_more: false,
                    total_count: 0,
                  },
                  capabilities: {},
                  requirements: {
                    errors: [],
                    past_due: [
                      "external_account",
                      "tos_acceptance.date",
                      "tos_acceptance.ip",
                    ],
                    alternatives: [],
                    currently_due: [
                      "external_account",
                      "tos_acceptance.date",
                      "tos_acceptance.ip",
                    ],
                    eventually_due: [
                      "external_account",
                      "tos_acceptance.date",
                      "tos_acceptance.ip",
                    ],
                    disabled_reason: "requirements.past_due",
                    current_deadline: null,
                    pending_verification: [],
                  },
                  business_type: "company",
                  tos_acceptance: {
                    ip: null,
                    date: null,
                    user_agent: null,
                  },
                  charges_enabled: false,
                  payouts_enabled: false,
                  business_profile: {
                    mcc: null,
                    url: null,
                    name: null,
                    support_url: null,
                    support_email: null,
                    support_phone: null,
                    annual_revenue: null,
                    support_address: null,
                    product_description: null,
                    estimated_worker_count: null,
                    minority_owned_business_designation: null,
                    specified_commercial_transactions_act_url: null,
                  },
                  default_currency: "usd",
                  details_submitted: false,
                  external_accounts: {
                    url: "/v1/accounts/acct_1Sz7zKHvAj2QHXKp/external_accounts",
                    data: [],
                    object: "list",
                    has_more: false,
                    total_count: 0,
                  },
                  future_requirements: {
                    errors: [],
                    past_due: [],
                    alternatives: [],
                    currently_due: [],
                    eventually_due: [],
                    disabled_reason: null,
                    current_deadline: null,
                    pending_verification: [],
                  },
                },
              },
              mxmerchant: {
                payment_link_id: "7c81274c-0cc0-431e-afcd-a78a45461511",
              },
            },
            logo_url: null,
            branding: {
              logo: "/static/photos/N399WS/0.jpg",
              color: "#18305A",
              contract:
                "/static/contract/7518894d-c4f4-41ad-889f-630ba7324c8a_20260223_125824.pdf",
              do85Registration:
                "/static/do85Registration/7518894d-c4f4-41ad-889f-630ba7324c8a_20260223_125803.pdf",
              part135Certification:
                "/static/part135Certification/7518894d-c4f4-41ad-889f-630ba7324c8a_20260223_125806.pdf",
            },
            organization_id: "94d76474-c055-4882-ab9d-651c29cf5fb9",
            created_at: "2025-09-30T22:45:47.201202",
            updated_at: "2026-04-16T09:28:41.801627",
          },
          bid_options: [
            {
              bid_id: "70e8b80a-0dc2-494e-9477-602ac816d29a",
              aircraft_id: "00034a22-c62a-4929-a04f-8c7ea8d8c1b6",
              operator_id: "f6ba8dec-e37e-430a-8123-a441ec8af797",
              base_price: "0.00",
              fuel_cost: "0.00",
              landing_fees: "0.00",
              crew_fees: "0.00",
              catering_cost: "0.00",
              ground_transport: "0.00",
              other_fees: "0.00",
              total_price: "0.00",
              broker_markup: "0.00",
              final_price: "16.22",
              is_recommended: true,
              recommendation_reason: ".",
              availability_confirmed: true,
              risk_level: "LOW",
              trust_score: "0.00",
              estimated_flight_time: 0,
              aircraft_features: {
                beds: 1,
                wifi: false,
                entertainment: false,
              },
              shortlisted: true,
              federal_excise_tax: "0.00",
              segment_tax: "15.60",
              operator_cost: "0.00",
              platform_fee: "0.00",
              status: "DRAFT",
              bid_option_id: "0fa7b7b1-60ee-49fa-a86b-af7224eba132",
              created_at: "2026-04-21T07:36:43.002753",
              updated_at: "2026-04-21T07:36:43.002753",
              aircraft: {
                tail_number: "N4571T",
                operator_id: "f6ba8dec-e37e-430a-8123-a441ec8af797",
                make_model: "PA-32-260",
                year: null,
                serial_number: "32-7200023",
                aircraft_type: null,
                passenger_capacity: null,
                range_nautical_miles: null,
                cruise_speed_knots: null,
                current_status: "AVAILABLE",
                last_maintenance: null,
                next_maintenance_due: null,
                insurance_expiry: null,
                home_base: null,
                hourly_rate: null,
                mfr_year: null,
                aw_date: null,
                registered_owner: null,
                registered_owner_state: null,
                fractional_owner: false,
                manufacturer: null,
                model: null,
                image_urls: null,
                banner_image_url: null,
                description: null,
                max_passengers: null,
                range_nm: null,
                cruise_speed_kts: null,
                aircraft_make_model_id:
                  "de169554-ae74-46d7-8603-57ee201b96c6",
                aircraft_id: "00034a22-c62a-4929-a04f-8c7ea8d8c1b6",
                created_at: "2026-01-11T05:06:45.611104",
                operator: {
                  name: "Vandeventer, Matthew S",
                  dba_name: null,
                  certificate_number: null,
                  ops_specs: null,
                  base_airport: null,
                  trust_score: null,
                  trust_score_updated_at: null,
                  financial_health_score: null,
                  regulatory_status: "COMPLIANT",
                  is_verified: false,
                  business_started_date: null,
                  argus_rating: null,
                  wyvern_rating: null,
                  aoc_part135: null,
                  is_bao: null,
                  acsf_ias: null,
                  telephone: null,
                  email: null,
                  website: null,
                  faa_operator_name: null,
                  faa_dsgn_code: "V9VC",
                  faa_ceo: null,
                  faa_city: null,
                  faa_state: null,
                  faa_pic_captains: null,
                  external_sources: {},
                  rating_tiers: "Pinnacle",
                  operator_id: "f6ba8dec-e37e-430a-8123-a441ec8af797",
                  created_at: "2026-01-11T04:21:15.907257",
                  updated_at: null,
                  ntsb_incidents: [],
                  ucc_verifications: [],
                  trust_scores: [],
                },
                aircraft_features: null,
                aircraft_amenities: null,
                aircraft_make_model: {
                  aircraft_make_model_id:
                    "de169554-ae74-46d7-8603-57ee201b96c6",
                  make_code: "PA",
                  model_code: "32",
                  manufacturer: "Piper",
                  model_name: "32",
                  aircraft_type: "Piston (Single-Engine)",
                  min_range: 460,
                  max_range: 1000,
                },
              },
              operator: {
                name: "Vandeventer, Matthew S",
                dba_name: null,
                certificate_number: null,
                ops_specs: null,
                base_airport: null,
                trust_score: null,
                trust_score_updated_at: null,
                financial_health_score: null,
                regulatory_status: "COMPLIANT",
                is_verified: false,
                business_started_date: null,
                argus_rating: null,
                wyvern_rating: null,
                aoc_part135: null,
                is_bao: null,
                acsf_ias: null,
                telephone: null,
                email: null,
                website: null,
                faa_operator_name: null,
                faa_dsgn_code: "V9VC",
                faa_ceo: null,
                faa_city: null,
                faa_state: null,
                faa_pic_captains: null,
                external_sources: {},
                rating_tiers: "Pinnacle",
                operator_id: "f6ba8dec-e37e-430a-8123-a441ec8af797",
                created_at: "2026-01-11T04:21:15.907257",
                updated_at: null,
                ntsb_incidents: [],
                ucc_verifications: [],
                trust_scores: [],
              },
            },
            {
              bid_id: "70e8b80a-0dc2-494e-9477-602ac816d29a",
              aircraft_id: "001c28e8-8407-4cef-8e33-be3256d2cce7",
              operator_id: "734725a6-5b15-4f1e-9842-25555c44c851",
              base_price: "0.00",
              fuel_cost: "0.00",
              landing_fees: "0.00",
              crew_fees: "0.00",
              catering_cost: "0.00",
              ground_transport: "0.00",
              other_fees: "0.00",
              total_price: "0.00",
              broker_markup: "0.00",
              final_price: "16.22",
              is_recommended: false,
              recommendation_reason: "",
              availability_confirmed: true,
              risk_level: "LOW",
              trust_score: "0.00",
              estimated_flight_time: 0,
              aircraft_features: {
                beds: 1,
                wifi: false,
                entertainment: false,
              },
              shortlisted: true,
              federal_excise_tax: "0.00",
              segment_tax: "15.60",
              operator_cost: "0.00",
              platform_fee: "0.00",
              status: "DRAFT",
              bid_option_id: "efc657df-1c10-449a-96ea-a7187f3a7c56",
              created_at: "2026-04-21T07:36:43.156353",
              updated_at: "2026-04-21T07:36:43.156353",
              aircraft: {
                tail_number: "N95GJ",
                operator_id: "734725a6-5b15-4f1e-9842-25555c44c851",
                make_model: "PC-12-47E",
                year: null,
                serial_number: "1395",
                aircraft_type: null,
                passenger_capacity: null,
                range_nautical_miles: null,
                cruise_speed_knots: null,
                current_status: "AVAILABLE",
                last_maintenance: null,
                next_maintenance_due: null,
                insurance_expiry: null,
                home_base: null,
                hourly_rate: null,
                mfr_year: null,
                aw_date: null,
                registered_owner: null,
                registered_owner_state: null,
                fractional_owner: false,
                manufacturer: null,
                model: null,
                image_urls: ["/static/photos/N95GJ/0.jpg"],
                banner_image_url: null,
                description: null,
                max_passengers: null,
                range_nm: null,
                cruise_speed_kts: null,
                aircraft_make_model_id:
                  "600415f1-cadb-42a0-94e9-c0a8e5954ed8",
                aircraft_id: "001c28e8-8407-4cef-8e33-be3256d2cce7",
                created_at: "2025-12-01T01:26:52.750456",
                operator: {
                  name: "Tradewind Aviation, Llc",
                  dba_name: null,
                  certificate_number: "TWYA123K",
                  ops_specs: null,
                  base_airport: null,
                  trust_score: 96.34,
                  trust_score_updated_at: "2026-01-09T02:08:53.144293",
                  financial_health_score: null,
                  regulatory_status: "COMPLIANT",
                  is_verified: true,
                  business_started_date: "2012-11-27T00:00:00",
                  argus_rating: "Gold",
                  wyvern_rating: "Registered",
                  aoc_part135: "TWYA123K",
                  is_bao: "No",
                  acsf_ias: "No",
                  telephone: "+1 203 267 3305",
                  email: "sales@flytradewind.com",
                  website: "http://www.stanstednews.com/privacy.html",
                  faa_operator_name: "TRADEWIND AVIATION, LLC",
                  faa_dsgn_code: "TWYA",
                  faa_ceo: "ZIPKIN, ERIC",
                  faa_city: "OXFORD",
                  faa_state: "CT",
                  faa_pic_captains: "82",
                  external_sources: {},
                  rating_tiers: "Pinnacle",
                  operator_id: "734725a6-5b15-4f1e-9842-25555c44c851",
                  created_at: "2025-11-20T15:57:10.141072",
                  updated_at: null,
                  ntsb_incidents: [],
                  ucc_verifications: [],
                  trust_scores: [
                    {
                      operator_id:
                        "734725a6-5b15-4f1e-9842-25555c44c851",
                      overall_score: 96.34,
                      safety_score: 100,
                      financial_score: 100,
                      regulatory_score: 100,
                      aog_score: 100,
                      factors: {
                        tail_score: 100,
                        fleet_score: 95.34,
                        tail_breakdown: {
                          formula: "100 - MRT + OST - 5*IHT",
                          components: {
                            IHT: {
                              value: 0.31,
                              description:
                                "Tail Incident History - 1 incident(s) found for this aircraft",
                            },
                            MRT: {
                              value: 0,
                              description:
                                "Tail Maintenance Risk - aircraft age is 5.0 years (ideal: 2-5 years)",
                            },
                            OST: {
                              value: 10,
                              description:
                                "Tail Ownership Status - operator has full ownership",
                            },
                          },
                          final_score: 100,
                        },
                        fleet_breakdown: {
                          formula: "100 - ORF + FSF - CSF",
                          components: {
                            CSF: {
                              value: 10,
                              description:
                                "Fleet Certification Penalty - None ARGUS, None WYVERN (lower is better, 0=best, 10=worst)",
                            },
                            FSF: {
                              value: 5,
                              description:
                                "Fleet Financial Score - positive values indicate good financial standing, negative indicates risk",
                            },
                            ORF: {
                              value: 0.13,
                              description:
                                "Fleet Operational Risk - higher values indicate more risk from incidents and accidents",
                            },
                          },
                          final_score: 94.87,
                        },
                      },
                      version: "1.0",
                      expires_at: "2026-02-08T02:08:53.144293",
                      confidence_level: 0.85,
                      trust_score_id:
                        "a1977916-d01c-4518-8587-8740c4928d7e",
                      calculated_at: "2026-01-09T02:08:53.144293",
                    },
                  ],
                },
                aircraft_features: null,
                aircraft_amenities: null,
                aircraft_make_model: {
                  aircraft_make_model_id:
                    "600415f1-cadb-42a0-94e9-c0a8e5954ed8",
                  make_code: "PC",
                  model_code: "12",
                  manufacturer: "Pilatus",
                  model_name: "Pilatus PC-12",
                  aircraft_type: "Fixed-wing Single-engine (Turboprop)",
                  min_range: 1300,
                  max_range: 1800,
                },
              },
              operator: {
                name: "Tradewind Aviation, Llc",
                dba_name: null,
                certificate_number: "TWYA123K",
                ops_specs: null,
                base_airport: null,
                trust_score: 96.34,
                trust_score_updated_at: "2026-01-09T02:08:53.144293",
                financial_health_score: null,
                regulatory_status: "COMPLIANT",
                is_verified: true,
                business_started_date: "2012-11-27T00:00:00",
                argus_rating: "Gold",
                wyvern_rating: "Registered",
                aoc_part135: "TWYA123K",
                is_bao: "No",
                acsf_ias: "No",
                telephone: "+1 203 267 3305",
                email: "sales@flytradewind.com",
                website: "http://www.stanstednews.com/privacy.html",
                faa_operator_name: "TRADEWIND AVIATION, LLC",
                faa_dsgn_code: "TWYA",
                faa_ceo: "ZIPKIN, ERIC",
                faa_city: "OXFORD",
                faa_state: "CT",
                faa_pic_captains: "82",
                external_sources: {},
                rating_tiers: "Pinnacle",
                operator_id: "734725a6-5b15-4f1e-9842-25555c44c851",
                created_at: "2025-11-20T15:57:10.141072",
                updated_at: null,
                ntsb_incidents: [],
                ucc_verifications: [],
                trust_scores: [
                  {
                    operator_id:
                      "734725a6-5b15-4f1e-9842-25555c44c851",
                    overall_score: 96.34,
                    safety_score: 100,
                    financial_score: 100,
                    regulatory_score: 100,
                    aog_score: 100,
                    factors: {
                      tail_score: 100,
                      fleet_score: 95.34,
                      tail_breakdown: {
                        formula: "100 - MRT + OST - 5*IHT",
                        components: {
                          IHT: {
                            value: 0.31,
                            description:
                              "Tail Incident History - 1 incident(s) found for this aircraft",
                          },
                          MRT: {
                            value: 0,
                            description:
                              "Tail Maintenance Risk - aircraft age is 5.0 years (ideal: 2-5 years)",
                          },
                          OST: {
                            value: 10,
                            description:
                              "Tail Ownership Status - operator has full ownership",
                          },
                        },
                        final_score: 100,
                      },
                      fleet_breakdown: {
                        formula: "100 - ORF + FSF - CSF",
                        components: {
                          CSF: {
                            value: 10,
                            description:
                              "Fleet Certification Penalty - None ARGUS, None WYVERN (lower is better, 0=best, 10=worst)",
                          },
                          FSF: {
                            value: 5,
                            description:
                              "Fleet Financial Score - positive values indicate good financial standing, negative indicates risk",
                          },
                          ORF: {
                            value: 0.13,
                            description:
                              "Fleet Operational Risk - higher values indicate more risk from incidents and accidents",
                          },
                        },
                        final_score: 94.87,
                      },
                    },
                    version: "1.0",
                    expires_at: "2026-02-08T02:08:53.144293",
                    confidence_level: 0.85,
                    trust_score_id:
                      "a1977916-d01c-4518-8587-8740c4928d7e",
                    calculated_at: "2026-01-09T02:08:53.144293",
                  },
                ],
              },
            },
            {
              bid_id: "70e8b80a-0dc2-494e-9477-602ac816d29a",
              aircraft_id: "00083cb7-4596-420f-8946-b67cb5b4caf2",
              operator_id: "28fcb9b8-46b8-442b-b328-7c0e79faae59",
              base_price: "0.00",
              fuel_cost: "0.00",
              landing_fees: "0.00",
              crew_fees: "0.00",
              catering_cost: "0.00",
              ground_transport: "0.00",
              other_fees: "0.00",
              total_price: "0.00",
              broker_markup: "0.00",
              final_price: "16.22",
              is_recommended: false,
              recommendation_reason: "",
              availability_confirmed: true,
              risk_level: "LOW",
              trust_score: "0.00",
              estimated_flight_time: 0,
              aircraft_features: {
                beds: 1,
                wifi: false,
                entertainment: false,
              },
              shortlisted: true,
              federal_excise_tax: "0.00",
              segment_tax: "15.60",
              operator_cost: "0.00",
              platform_fee: "0.00",
              status: "DRAFT",
              bid_option_id: "bf22f205-cd90-4255-a249-88303bb250e9",
              created_at: "2026-04-21T07:36:43.230896",
              updated_at: "2026-04-21T07:36:43.230896",
              aircraft: {
                tail_number: "N399WS",
                operator_id: "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                make_model: "BE-90-C90A",
                year: null,
                serial_number: "LJ-1547",
                aircraft_type: null,
                passenger_capacity: null,
                range_nautical_miles: null,
                cruise_speed_knots: null,
                current_status: "AVAILABLE",
                last_maintenance: null,
                next_maintenance_due: null,
                insurance_expiry: null,
                home_base: null,
                hourly_rate: null,
                mfr_year: null,
                aw_date: null,
                registered_owner: null,
                registered_owner_state: null,
                fractional_owner: false,
                manufacturer: null,
                model: null,
                image_urls: [
                  "/static/photos/N399WS/0.jpg",
                  "/static/photos/N399WS/1.jpg",
                  "/static/photos/N399WS/10.jpg",
                  "/static/photos/N399WS/11.jpg",
                  "/static/photos/N399WS/12.jpg",
                  "/static/photos/N399WS/13.jpg",
                  "/static/photos/N399WS/14.jpg",
                  "/static/photos/N399WS/15.jpg",
                  "/static/photos/N399WS/16.jpg",
                  "/static/photos/N399WS/17.jpg",
                  "/static/photos/N399WS/18.jpg",
                  "/static/photos/N399WS/19.jpg",
                  "/static/photos/N399WS/2.jpg",
                  "/static/photos/N399WS/20.jpg",
                  "/static/photos/N399WS/21.jpg",
                  "/static/photos/N399WS/3.jpg",
                  "/static/photos/N399WS/4.jpg",
                  "/static/photos/N399WS/5.jpg",
                  "/static/photos/N399WS/6.jpg",
                  "/static/photos/N399WS/7.jpg",
                  "/static/photos/N399WS/8.jpg",
                  "/static/photos/N399WS/9.jpg",
                ],
                banner_image_url: null,
                description: null,
                max_passengers: null,
                range_nm: null,
                cruise_speed_kts: null,
                aircraft_make_model_id:
                  "8f4ebbfe-7e54-4bff-aae5-53d668f27dca",
                aircraft_id: "00083cb7-4596-420f-8946-b67cb5b4caf2",
                created_at: "2025-12-01T01:24:50.216587",
                operator: {
                  name: "Guardian Flight, Llc.",
                  dba_name: null,
                  certificate_number: "G1IA720A",
                  ops_specs: null,
                  base_airport: null,
                  trust_score: 96.38,
                  trust_score_updated_at: "2026-01-09T00:50:03.316776",
                  financial_health_score: 100,
                  regulatory_status: "COMPLIANT",
                  is_verified: true,
                  business_started_date: "1994-01-11T00:00:00",
                  argus_rating: "No",
                  wyvern_rating: "No",
                  aoc_part135: "G1IA720A (Guardian Flight LLC)",
                  is_bao: "No",
                  acsf_ias: "No",
                  telephone: "+1 435 678 3222",
                  email: "jimhunt@eagleairmed.com",
                  website: "http://www.stanstednews.com/privacy.html",
                  faa_operator_name: "GUARDIAN FLIGHT, LLC.",
                  faa_dsgn_code: "G1IA",
                  faa_ceo: "BURNS, CHRISTOPHER",
                  faa_city: "LEWISVILLE",
                  faa_state: "TX",
                  faa_pic_captains: "235",
                  external_sources: {},
                  rating_tiers: "Pinnacle",
                  operator_id: "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                  created_at: "2025-11-20T15:54:53.284428",
                  updated_at: null,
                  ntsb_incidents: [],
                  ucc_verifications: [],
                  trust_scores: [
                    {
                      operator_id:
                        "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                      overall_score: 96.38,
                      safety_score: 100,
                      financial_score: 100,
                      regulatory_score: 100,
                      aog_score: 100,
                      factors: {
                        tail_score: 100,
                        fleet_score: 95.4,
                        tail_breakdown: {
                          formula: "100 - MRT + OST - 5*IHT",
                          components: {
                            IHT: {
                              value: 0,
                              description:
                                "Tail Incident History - 0 incident(s) found for this aircraft",
                            },
                            MRT: {
                              value: 0,
                              description:
                                "Tail Maintenance Risk - aircraft age is 5.0 years (ideal: 2-5 years)",
                            },
                            OST: {
                              value: 10,
                              description:
                                "Tail Ownership Status - operator has full ownership",
                            },
                          },
                          explanation:
                            "This aircraft achieved a perfect Tail Score of 100/100 primarily due to its optimal age of 5 years, which places it in the ideal operational window for minimal maintenance risk, combined with zero reported incidents in its history. The aircraft's age strikes an excellent balance between being new enough to incorporate modern safety features while having sufficient operational data, and the full ownership by Eagle Air Med indicates stable maintenance oversight and operational control. Based on these metrics, this aircraft demonstrates exceptional reliability with minimal risk factors, making it an exemplary asset for medical aviation operations.",
                          final_score: 100,
                        },
                        fleet_breakdown: {
                          formula: "100 - ORF + FSF - CSF",
                          components: {
                            CSF: {
                              value: 10,
                              description:
                                "Fleet Certification Penalty - None ARGUS, None WYVERN (lower is better, 0=best, 10=worst)",
                            },
                            FSF: {
                              value: 5,
                              description:
                                "Fleet Financial Score - positive values indicate good financial standing, negative indicates risk",
                            },
                            ORF: {
                              value: 0,
                              description:
                                "Fleet Operational Risk - higher values indicate more risk from incidents and accidents",
                            },
                          },
                          explanation:
                            "Based on the data provided, Eagle Air Med's Fleet Score of 95/100 primarily reflects their clean operational history with zero reported events and no financial red flags, demonstrating strong operational safety performance over their 10-year history. The only minor deduction appears to be from lacking third-party safety certifications (ARGUS/WYVERN), which while not critical, represents an opportunity for enhanced safety validation. Overall, this score indicates a highly reliable operator with consistent safety practices, though obtaining industry safety certifications could further strengthen their standing.",
                          final_score: 95,
                        },
                      },
                      version: "1.0",
                      expires_at: "2026-02-08T00:50:04.457853",
                      confidence_level: 0.85,
                      trust_score_id:
                        "8b378802-2055-44fc-a12d-c966d86cfab7",
                      calculated_at: "2026-01-09T00:50:04.457853",
                    },
                    {
                      operator_id:
                        "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                      overall_score: 96.38,
                      safety_score: 100,
                      financial_score: 100,
                      regulatory_score: 100,
                      aog_score: 100,
                      factors: {
                        tail_score: 100,
                        fleet_score: 95.4,
                        tail_breakdown: {
                          formula: "100 - MRT + OST - 5*IHT",
                          components: {
                            IHT: {
                              value: 0,
                              description:
                                "Tail Incident History - 0 incident(s) found for this aircraft",
                            },
                            MRT: {
                              value: 0,
                              description:
                                "Tail Maintenance Risk - aircraft age is 5.0 years (ideal: 2-5 years)",
                            },
                            OST: {
                              value: 10,
                              description:
                                "Tail Ownership Status - operator has full ownership",
                            },
                          },
                          explanation:
                            "This aircraft achieved a perfect Tail Score of 100/100 primarily due to its optimal age of 5 years, which represents the sweet spot between new aircraft reliability and proven operational history, resulting in a minimal Maintenance Risk (MRT) score of 0.00. The full ownership by Eagle Air Med contributes positively to the score through the maximum Ownership Status (OST) rating of 10, as direct ownership typically indicates consistent maintenance control and operational oversight. With zero recorded incidents and an ideal age profile, this aircraft demonstrates excellent reliability metrics, suggesting optimal safety performance and well-maintained operational conditions for its medical transport mission profile.",
                          final_score: 100,
                        },
                        fleet_breakdown: {
                          formula: "100 - ORF + FSF - CSF",
                          components: {
                            CSF: {
                              value: 10,
                              description:
                                "Fleet Certification Penalty - None ARGUS, None WYVERN (lower is better, 0=best, 10=worst)",
                            },
                            FSF: {
                              value: 5,
                              description:
                                "Fleet Financial Score - positive values indicate good financial standing, negative indicates risk",
                            },
                            ORF: {
                              value: 0,
                              description:
                                "Fleet Operational Risk - higher values indicate more risk from incidents and accidents",
                            },
                          },
                          explanation:
                            "Based on the data provided, Eagle Air Med's Fleet Score of 95/100 reflects a strong safety profile, primarily driven by their clean operational history with zero reported events and no financial red flags over their 10-year operational period. The absence of UCC filings and bankruptcies indicates financial stability, though the lack of third-party safety certifications (ARGUS/WYVERN) represents a minor gap in their overall assessment. While their small fleet size (1 aircraft) could potentially increase operational vulnerability, their decade of incident-free operations and stable financial indicators suggest they maintain reliable and consistent safety standards.",
                          final_score: 95,
                        },
                      },
                      version: "1.0",
                      expires_at: "2026-02-08T00:50:03.316776",
                      confidence_level: 0.85,
                      trust_score_id:
                        "2b762615-ee64-4ef0-8685-f1de62a81c9d",
                      calculated_at: "2026-01-09T00:50:03.316776",
                    },
                  ],
                },
                aircraft_features: null,
                aircraft_amenities: null,
                aircraft_make_model: {
                  aircraft_make_model_id:
                    "8f4ebbfe-7e54-4bff-aae5-53d668f27dca",
                  make_code: "BE",
                  model_code: "90",
                  manufacturer: "Beechcraft",
                  model_name: "90",
                  aircraft_type: "Turboprop (Multi-Engine)",
                  min_range: 600,
                  max_range: 1800,
                },
              },
              operator: {
                name: "Guardian Flight, Llc.",
                dba_name: null,
                certificate_number: "G1IA720A",
                ops_specs: null,
                base_airport: null,
                trust_score: 96.38,
                trust_score_updated_at: "2026-01-09T00:50:03.316776",
                financial_health_score: 100,
                regulatory_status: "COMPLIANT",
                is_verified: true,
                business_started_date: "1994-01-11T00:00:00",
                argus_rating: "No",
                wyvern_rating: "No",
                aoc_part135: "G1IA720A (Guardian Flight LLC)",
                is_bao: "No",
                acsf_ias: "No",
                telephone: "+1 435 678 3222",
                email: "jimhunt@eagleairmed.com",
                website: "http://www.stanstednews.com/privacy.html",
                faa_operator_name: "GUARDIAN FLIGHT, LLC.",
                faa_dsgn_code: "G1IA",
                faa_ceo: "BURNS, CHRISTOPHER",
                faa_city: "LEWISVILLE",
                faa_state: "TX",
                faa_pic_captains: "235",
                external_sources: {},
                rating_tiers: "Pinnacle",
                operator_id: "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                created_at: "2025-11-20T15:54:53.284428",
                updated_at: null,
                ntsb_incidents: [],
                ucc_verifications: [],
                trust_scores: [
                  {
                    operator_id:
                      "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                    overall_score: 96.38,
                    safety_score: 100,
                    financial_score: 100,
                    regulatory_score: 100,
                    aog_score: 100,
                    factors: {
                      tail_score: 100,
                      fleet_score: 95.4,
                      tail_breakdown: {
                        formula: "100 - MRT + OST - 5*IHT",
                        components: {
                          IHT: {
                            value: 0,
                            description:
                              "Tail Incident History - 0 incident(s) found for this aircraft",
                          },
                          MRT: {
                            value: 0,
                            description:
                              "Tail Maintenance Risk - aircraft age is 5.0 years (ideal: 2-5 years)",
                          },
                          OST: {
                            value: 10,
                            description:
                              "Tail Ownership Status - operator has full ownership",
                          },
                        },
                        explanation:
                          "This aircraft achieved a perfect Tail Score of 100/100 primarily due to its optimal age of 5 years, which places it in the ideal operational window for minimal maintenance risk, combined with zero reported incidents in its history. The aircraft's age strikes an excellent balance between being new enough to incorporate modern safety features while having sufficient operational data, and the full ownership by Eagle Air Med indicates stable maintenance oversight and operational control. Based on these metrics, this aircraft demonstrates exceptional reliability with minimal risk factors, making it an exemplary asset for medical aviation operations.",
                        final_score: 100,
                      },
                      fleet_breakdown: {
                        formula: "100 - ORF + FSF - CSF",
                        components: {
                          CSF: {
                            value: 10,
                            description:
                              "Fleet Certification Penalty - None ARGUS, None WYVERN (lower is better, 0=best, 10=worst)",
                          },
                          FSF: {
                            value: 5,
                            description:
                              "Fleet Financial Score - positive values indicate good financial standing, negative indicates risk",
                          },
                          ORF: {
                            value: 0,
                            description:
                              "Fleet Operational Risk - higher values indicate more risk from incidents and accidents",
                          },
                        },
                        explanation:
                          "Based on the data provided, Eagle Air Med's Fleet Score of 95/100 primarily reflects their clean operational history with zero reported events and no financial red flags, demonstrating strong operational safety performance over their 10-year history. The only minor deduction appears to be from lacking third-party safety certifications (ARGUS/WYVERN), which while not critical, represents an opportunity for enhanced safety validation. Overall, this score indicates a highly reliable operator with consistent safety practices, though obtaining industry safety certifications could further strengthen their standing.",
                        final_score: 95,
                      },
                    },
                    version: "1.0",
                    expires_at: "2026-02-08T00:50:04.457853",
                    confidence_level: 0.85,
                    trust_score_id:
                      "8b378802-2055-44fc-a12d-c966d86cfab7",
                    calculated_at: "2026-01-09T00:50:04.457853",
                  },
                  {
                    operator_id:
                      "28fcb9b8-46b8-442b-b328-7c0e79faae59",
                    overall_score: 96.38,
                    safety_score: 100,
                    financial_score: 100,
                    regulatory_score: 100,
                    aog_score: 100,
                    factors: {
                      tail_score: 100,
                      fleet_score: 95.4,
                      tail_breakdown: {
                        formula: "100 - MRT + OST - 5*IHT",
                        components: {
                          IHT: {
                            value: 0,
                            description:
                              "Tail Incident History - 0 incident(s) found for this aircraft",
                          },
                          MRT: {
                            value: 0,
                            description:
                              "Tail Maintenance Risk - aircraft age is 5.0 years (ideal: 2-5 years)",
                          },
                          OST: {
                            value: 10,
                            description:
                              "Tail Ownership Status - operator has full ownership",
                          },
                        },
                        explanation:
                          "This aircraft achieved a perfect Tail Score of 100/100 primarily due to its optimal age of 5 years, which represents the sweet spot between new aircraft reliability and proven operational history, resulting in a minimal Maintenance Risk (MRT) score of 0.00. The full ownership by Eagle Air Med contributes positively to the score through the maximum Ownership Status (OST) rating of 10, as direct ownership typically indicates consistent maintenance control and operational oversight. With zero recorded incidents and an ideal age profile, this aircraft demonstrates excellent reliability metrics, suggesting optimal safety performance and well-maintained operational conditions for its medical transport mission profile.",
                        final_score: 100,
                      },
                      fleet_breakdown: {
                        formula: "100 - ORF + FSF - CSF",
                        components: {
                          CSF: {
                            value: 10,
                            description:
                              "Fleet Certification Penalty - None ARGUS, None WYVERN (lower is better, 0=best, 10=worst)",
                          },
                          FSF: {
                            value: 5,
                            description:
                              "Fleet Financial Score - positive values indicate good financial standing, negative indicates risk",
                          },
                          ORF: {
                            value: 0,
                            description:
                              "Fleet Operational Risk - higher values indicate more risk from incidents and accidents",
                          },
                        },
                        explanation:
                          "Based on the data provided, Eagle Air Med's Fleet Score of 95/100 reflects a strong safety profile, primarily driven by their clean operational history with zero reported events and no financial red flags over their 10-year operational period. The absence of UCC filings and bankruptcies indicates financial stability, though the lack of third-party safety certifications (ARGUS/WYVERN) represents a minor gap in their overall assessment. While their small fleet size (1 aircraft) could potentially increase operational vulnerability, their decade of incident-free operations and stable financial indicators suggest they maintain reliable and consistent safety standards.",
                        final_score: 95,
                      },
                    },
                    version: "1.0",
                    expires_at: "2026-02-08T00:50:03.316776",
                    confidence_level: 0.85,
                    trust_score_id:
                      "2b762615-ee64-4ef0-8685-f1de62a81c9d",
                    calculated_at: "2026-01-09T00:50:03.316776",
                  },
                ],
              },
            },
          ],
        },
      },
    ],
    client: {
      first_name: "Kervin",
      last_name: "Kervin",
      birth_date: "1990-12-12T00:00:00",
      address1: "123 East 85th Street, Apt 5G",
      address2: "add2",
      city: "New York City",
      state: "New York",
      country: "country",
      zip_code: "123",
      contact_numbers: ["+112345678"],
      email: "kgatchalian@trustjet.ai",
      passport_num: null,
      nationality: null,
      company_name: "NewCompany",
      company_address: null,
      broker_id: "bedf3852-a2f2-4a7c-885c-4cce9d6ad067",
      payment_info: {
        stripe: {
          stripe_customer_id: "cus_TveFrMI18U1aSR",
        },
        mxmerchant: {
          customer_id: 10000001652878,
          customer_number: "758cbb92-56b3-4421-a22e-862d637325f5",
        },
      },
      client_id: "758cbb92-56b3-4421-a22e-862d637325f5",
      created_at: "2026-02-06T11:11:13.624849Z",
      updated_at: "2026-04-09T12:32:53.186776Z",
    },
  },
  quoteLink:
    "http://localhost:3000/quotepreview?quote=f9dba03d-ec2e-4ac6-8155-6dcb78c12936&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl9pZCI6ImNoZWNrb3V0XzQyYWFiZjhkOWY0YThiYzQyNDIwNTIzY2U4ODJjZWIxIiwicXVvdGVfaWQiOiJmOWRiYTAzZC1lYzJlLTRhYzYtODE1NS02ZGNiNzhjMTI5MzYiLCJhbW91bnQiOjQ4LjY2LCJjdXJyZW5jeSI6IlVTRCIsInBheW1lbnRfbWV0aG9kIjoiQ1JFRElUX0NBUkQiLCJkZXNjcmlwdGlvbiI6IkNoYXJ0ZXIgZmxpZ2h0IHF1b3RlIHBheW1lbnQiLCJtZXRhZGF0YSI6eyJjdXN0b21lcl9uYW1lIjoiSm9obiBEb2UiLCJjdXN0b21lcl9lbWFpbCI6ImpvaG5AZXhhbXBsZS5jb20ifSwiaWF0IjoxNzc2NzU3MDA1LCJleHAiOjE3NzY4NDM0MDUsInR5cGUiOiJjaGVja291dCJ9.NjAetlNZcSQ_gEDnvC_XMRl-2Deo-y8yClk5gnnv_hw&org=94d76474-c055-4882-ab9d-651c29cf5fb9",
  passengers: [],
  crew: null,
  services: [],
};
